<template>
  <div class="mx-auto container container--fluid">
    <!-- <div>
      <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

    </div> -->
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-card class="box">
      <v-toolbar dense class="toolbar" flat color="white">
        <v-toolbar-title>Visitor URL</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-dialog v-model="dialog" max-width="500px">
        <template v-slot:activator="{ on }">
          <v-btn class="mb-2 button" v-on="on" small>Add Visitor URL</v-btn>
        </template>
        <v-card>
          <v-form v-model="valid">
            <v-card-title class="toolbar">
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" sm="12" md="12">
                    <v-text-field v-model="editedItem.url" persistent-hint hint="eduplusnow.com..." label="Visitor URL"
                      :rules="[(v) => !!v || 'required']"></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn class="mb-2 button" text @click="close">Cancel</v-btn>
              <v-btn class="mb-2 button" color="primary" @click="save">Save</v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>
    </v-card>
    <v-card class="box" v-if="url">
      <v-card-text class="text-center">
        <v-card-title>
          <v-row>
            <v-col align-self="center">
              <span><a :href="url" target="blank">{{ url }}</a></span>
            </v-col>
            <v-col>
              <center>
                <qrcode-vue v-if="value != null" :value="value" :size="150" level="H" />
              </center>
            </v-col>
          </v-row>
        </v-card-title>
        <v-card-actions>
          <v-row>
            <v-col>
              <span><v-avatar style="" size="25" class="edit-avatar">
                  <v-icon class="edit-v-icon mr-2" @click="editItem(url)">edit</v-icon>
                </v-avatar></span>
            </v-col>
            <col>
            <v-switch inset v-model="isactive" :color="isactive ? 'success' : 'primary'" @change="toggle()"></v-switch>
          </v-row>
          <v-col>
            <v-btn rounded text title="Delete Link" :loading="delete_load" @click="deleteLink()">
              <v-icon color="red">mdi-trash-can</v-icon>
            </v-btn>
          </v-col>
          </v-row>
        </v-card-actions>
      </v-card-text>
    </v-card>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import QrcodeVue from "qrcode.vue";
import axios from "axios";
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed

export default {
  components: {
    QrcodeVue,
  
      Breadcrumbs,
  
  },
  data: () => ({
    delete_load: false,
    valid: false,
    overlay: false,
    // extraBreadcrumbItems: [
    //   { text: "URL Master", disabled: true, href: "" },

    // ],
    // breadcrumbClass: "breadcrumb-style2",
    errorMsg: {
      name: false,
    },
    snackbar_msg: "",
    color: "",
    snackbar: false,
    search: "",
    dialog: false,
    url: "",
    isactive: true,
    // value:"",
    value: null,
    visit_type_array_list: [],
    editedIndex: -1,
    editedItem: {
      id: "",
      url: "",
      isactive: true,
    },
    defaultItem: {
      id: "",
      url: "",
      isactive: true,
    },
  }),

  mounted() {
    this.onLoad();
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "New Visitor Link" : "Edit Visitor Link";
    },
  },
  methods: {
    deleteLink() {
      if (!confirm("Are you sure you want to delete this visitor link?"))
        return;
      this.overlay = true;
      axios
        .post("/VisitorManagement/deleteVisitorURL")
        .then((res) => {
          this.overlay = false;
          if (res.data.code == "SUCCESS") {
            this.showSnackbar("#4caf50", "Visitor Link Deleted!"); // show snackbar
            location.reload();
          } else if (res.data.code == "NA") {
            this.showSnackbar(
              "#4caf50",
              "Something went wrong, Please try again later!"
            ); // show snackbar
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
        })
        .catch((error) => {
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },
    editItem(url) {
      this.editedIndex = 1;
      this.editedItem.url = url;
      this.dialog = true;
    },
    onLoad() {
      this.overlay = true;
      axios
        .post("/VisitorManagement/visitorURL")
        .then((res) => {
          this.overlay = false;
          if (res.data.msg == "200") {
            this.overlay = false;
            if (res.data.visitor_url_data) {
              this.url = res.data.visitor_url_data[0].value;
              this.value = res.data.visitor_url_data[0].value;
              this.isactive = res.data.visitor_url_data[0].isactive;
            }
          } else {
            this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
          window.console.log(error);
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    save() {
      if (this.editedIndex > -1) {
        if (this.editedItem.url.length != 0) {
          let regexp =
            /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)/;
          if (!regexp.test(this.editedItem.url)) {
            this.showSnackbar("#b71c1c", "Please enter valid URL!");
            return;
          }
        }
        axios
          .post("/VisitorManagement/editVisitorURL", this.editedItem)
          .then((res) => {
            if (res.data.code == "SUCCESS") {
              //window.alert(res.data.msg)
              this.showSnackbar(
                "#4caf50",
                "Visitor Link Updated Successfully..."
              ); // show snackbar on success
              this.onLoad();
            } else if (res.data.code == "NA") {
              this.showSnackbar("#b71c1c", "Something went wrong!"); // show snackbar on error
              sessionStorage.setItem("error-trace", res.data.error_trace);
            }
          })
          .catch((error) => {
            window.console.log(error);
          });
        this.close();
      } else {
        if (this.editedItem.url.length != 0) {
          let regexp =
            /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)/;
          if (!regexp.test(this.editedItem.url)) {
            this.showSnackbar("#b71c1c", "Please enter valid URL!");
            return;
          }
        }
        axios
          .post("/VisitorManagement/saveVisitorURL", this.editedItem)
          .then((res) => {
            if (res.data.code == "SUCCESS") {
              //window.alert(res.data.status.code)
              this.showSnackbar(
                "#4caf50",
                "Visitor Link Added Successfully..."
              ); // show snackbar on success
              this.onLoad();
            } else if (res.data.code == "NA") {
              //window.alert(res.data.status.code)
              //alert(res.data.status.message)
              this.showSnackbar("#b71c1c", "Only One Visitor Link Allowed!"); // show snackbar on error
              sessionStorage.setItem("error-trace", res.data.error_trace);
            }
          })
          .catch((error) => {
            window.console.log(error);
          });
        this.close();
      }
    }, //save()
    toggle() {
      const data = {
        toggle: this.isactive,
      };
      this.overlay = true;
      axios
        .post("/VisitorManagement/toggleVisitorURL", data)
        .then((res) => {
          this.overlay = false;
          if (res.data.code == "SUCCESS") {
            this.showSnackbar("#4caf50", "Visitor Link Status Changed!"); // show snackbar
          } else if (res.data.code == "NA") {
            this.showSnackbar(
              "#4caf50",
              "Something went wrong, Please try again later!"
            ); // show snackbar
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
        })
        .catch((error) => {
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
        });
    },
  },
};
</script>
<style scoped>
.v-text-field {
  padding-top: 0px;
  margin-top: 0px;
}
.v-icon-size {
  font-size: 20px;
}
.edit-avatar {
  transition: 0.3s;
  border: 1px solid #b0bec5;
}
.edit-avatar:hover {
  background-color: #b0bec5;
}
.edit-v-icon {
  padding-left: 6px;
  font-size: 15px;
}
.edit-v-icon:hover {
  color: white;
}
.mytable /deep/ thead th {
  background: #0f2027; /* fallback for old browsers */
  background: -webkit-linear-gradient(
    to right,
    #2c5364,
    #203a43,
    #0f2027
  ); /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(
    to right,
    #2c5364,
    #203a43,
    #0f2027
  ); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
  background-color: #0f2027 !important;
  color: white !important;
  font-weight: bold !important;
  white-space: nowrap !important;
  text-align: center;
}
</style>